
{
  "familyId": "GET-WETENSCHAP-REKEN",
  "questions": [
    {
      "id": "GET-WETENSCHAP-REKEN-001",
      "familyId": "GET-WETENSCHAP-REKEN",
      "module": "Getalbegrip",
      "tier": 16,
      "levelCode": "E8+",
      "group": 8,
      "skill": "wetenschappelijk",
      "subSkill": "wetenschap_rekenen",
      "questionType": "multiple_choice",
      "question": "Een astronoom telt sterren in twee sterrenstelsels: $3 \\times 10^{4}$ en $2 \\times 10^{4}$. Hoeveel sterren zijn er in totaal?",
      "options": ["$5 \\times 10^{4}$", "$5 \\times 10^{8}$", "$6 \\times 10^{4}$", "$6 \\times 10^{8}$"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Optellen in wetenschappelijke notatie",
            "content": "Bij dezelfde macht van 10 tel je de coëfficiënten op. De exponent blijft gelijk. Voorbeeld: $3 \\times 10^{4} + 2 \\times 10^{4} = (3+2) \\times 10^{4} = 5 \\times 10^{4}$.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "wetenschap_optellen",
      "variantIndex": 1,
      "citoDifficulty": 0.65,
      "citoDiscrimination": 0.73,
      "pedagogy": {
        "dok": 3,
        "misconceptionTags": [
          { "id": "get.wetenschap-exponent-optellen", "label": "Exponenten optellen bij optelling", "optionIndex": 1 },
          { "id": "get.wetenschap-coefficient-keer", "label": "Coëfficiënten vermenigvuldigd i.p.v. opgeteld", "optionIndex": 2 },
          { "id": "get.wetenschap-niet-uitgerekend", "label": "Exponent-som niet uitgerekend", "optionIndex": 3 }
        ]
      },
      "feedback": {
        "explanationText": "Bij dezelfde macht van 10 tel je de coëfficiënten op. Beide getallen hebben dezelfde macht: $10^{4}$. Coëfficiënten: 3 + 2 = 5. Antwoord: $5 \\times 10^{4}$.",
        "solutionSteps": [
          "Controleer: zelfde macht van 10? Ja, beide $10^{4}$",
          "Tel coëfficiënten op: 3 + 2 = 5",
          "Antwoord: $5 \\times 10^{4}$"
        ],
        "distractorExplanations": {
          "0": "Goed! $3 \\times 10^{4} + 2 \\times 10^{4} = (3 + 2) \\times 10^{4} = 5 \\times 10^{4}$.",
          "1": "Je dacht waarschijnlijk dat je de exponenten optelt. Maar bij optellen blijft de exponent gelijk: $10^{4} + 10^{4} \\neq 10^{8}$. Onthoud: exponenten optellen doe je alleen bij vermenigvuldigen.",
          "2": "Je dacht waarschijnlijk dat je de coëfficiënten vermenigvuldigt. Maar 3 + 2 = 5, niet 3 × 2 = 6. Onthoud: bij optellen tel je de coëfficiënten op.",
          "3": "Je hebt de coëfficiënten vermenigvuldigd én de exponenten opgeteld (3 × 2 = 6 en 4 + 4 = 8). Bij optellen tel je alleen de coëfficiënten op en blijft de exponent gelijk."
        }
      }
    },
    {
      "id": "GET-WETENSCHAP-REKEN-002",
      "familyId": "GET-WETENSCHAP-REKEN",
      "module": "Getalbegrip",
      "tier": 16,
      "levelCode": "E8+",
      "group": 8,
      "skill": "wetenschappelijk",
      "subSkill": "wetenschap_rekenen",
      "questionType": "multiple_choice",
      "question": "Een microbioloog berekent het aantal bacteriën: $(2 \\times 10^{3}) \\times (4 \\times 10^{2})$. Wat is het antwoord?",
      "options": ["$8 \\times 10^{5}$", "$8 \\times 10^{6}$", "$6 \\times 10^{5}$", "$8 \\times 10^{1}$"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Vermenigvuldigen in wetenschappelijke notatie",
            "content": "Vermenigvuldig de coëfficiënten en tel de exponenten op. $(a \\times 10^{n}) \\times (b \\times 10^{m}) = (a \\times b) \\times 10^{n+m}$.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "wetenschap_vermenigvuldigen",
      "variantIndex": 2,
      "citoDifficulty": 0.68,
      "citoDiscrimination": 0.70,
      "pedagogy": {
        "dok": 3,
        "misconceptionTags": [
          { "id": "get.wetenschap-exponent-keer", "label": "Exponenten vermenigvuldigd i.p.v. opgeteld", "optionIndex": 1 },
          { "id": "get.wetenschap-coefficient-plus", "label": "Coëfficiënten opgeteld i.p.v. vermenigvuldigd", "optionIndex": 2 },
          { "id": "get.wetenschap-niet-uitgerekend", "label": "Exponent-som niet uitgerekend", "optionIndex": 3 }
        ]
      },
      "feedback": {
        "explanationText": "Vermenigvuldig de coëfficiënten en tel de exponenten op. Coëfficiënten: 2 × 4 = 8. Exponenten: $10^{3} \\times 10^{2} = 10^{3+2} = 10^{5}$. Antwoord: $8 \\times 10^{5}$.",
        "solutionSteps": [
          "Coëfficiënten vermenigvuldigen: 2 × 4 = 8",
          "Exponenten optellen: 3 + 2 = 5",
          "Antwoord: $8 \\times 10^{5}$"
        ],
        "distractorExplanations": {
          "0": "Goed! $(2 \\times 4) \\times 10^{3+2} = 8 \\times 10^{5}$.",
          "1": "Je dacht waarschijnlijk dat je de exponenten vermenigvuldigt. Maar $10^{3} \\times 10^{2} = 10^{5}$ (exponenten optellen), niet $10^{6}$. Onthoud: bij vermenigvuldigen tel je de exponenten op.",
          "2": "Je dacht waarschijnlijk dat je de coëfficiënten optelt. Maar 2 × 4 = 8 (vermenigvuldigen), niet 2 + 4 = 6. Onthoud: coëfficiënten vermenigvuldigen, exponenten optellen.",
          "3": "Je hebt de exponenten afgetrokken (3 - 2 = 1). Bij vermenigvuldigen moet je de exponenten juist optellen (3 + 2 = 5)."
        }
      }
    },
    {
      "id": "GET-WETENSCHAP-REKEN-003",
      "familyId": "GET-WETENSCHAP-REKEN",
      "module": "Getalbegrip",
      "tier": 16,
      "levelCode": "E8+",
      "group": 8,
      "skill": "wetenschappelijk",
      "subSkill": "wetenschap_rekenen",
      "questionType": "multiple_choice",
      "question": "Een natuurkundige deelt twee metingen: $(9 \\times 10^{6}) \\div (3 \\times 10^{2})$. Wat is het antwoord?",
      "options": ["$3 \\times 10^{4}$", "$3 \\times 10^{3}$", "$6 \\times 10^{4}$", "$3 \\times 10^{8}$"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Delen in wetenschappelijke notatie",
            "content": "Deel de coëfficiënten en trek de exponenten af. $(a \\times 10^{n}) \\div (b \\times 10^{m}) = (a \\div b) \\times 10^{n-m}$.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "wetenschap_delen",
      "variantIndex": 3,
      "citoDifficulty": 0.70,
      "citoDiscrimination": 0.69,
      "pedagogy": {
        "dok": 3,
        "misconceptionTags": [
          { "id": "get.wetenschap-exponent-delen", "label": "Exponenten gedeeld i.p.v. afgetrokken", "optionIndex": 1 },
          { "id": "get.wetenschap-coefficient-min", "label": "Coëfficiënten afgetrokken i.p.v. gedeeld", "optionIndex": 2 },
          { "id": "get.wetenschap-exponent-optellen", "label": "Exponenten opgeteld bij deling", "optionIndex": 3 }
        ]
      },
      "feedback": {
        "explanationText": "Deel de coëfficiënten en trek de exponenten af. Coëfficiënten: 9 ÷ 3 = 3. Exponenten: $10^{6} \\div 10^{2} = 10^{6-2} = 10^{4}$. Antwoord: $3 \\times 10^{4}$.",
        "solutionSteps": [
          "Coëfficiënten delen: 9 ÷ 3 = 3",
          "Exponenten aftrekken: 6 − 2 = 4",
          "Antwoord: $3 \\times 10^{4}$"
        ],
        "distractorExplanations": {
          "0": "Goed! $(9 \\div 3) \\times 10^{6-2} = 3 \\times 10^{4}$.",
          "1": "Je dacht waarschijnlijk dat je de exponenten deelt. Maar $10^{6} \\div 10^{2} = 10^{4}$ (exponenten aftrekken), niet $10^{3}$. Onthoud: bij delen trek je de exponenten af.",
          "2": "Je dacht waarschijnlijk dat je de coëfficiënten aftrekt. Maar 9 ÷ 3 = 3 (delen), niet 9 − 3 = 6. Onthoud: coëfficiënten delen, exponenten aftrekken.",
          "3": "Je dacht waarschijnlijk dat je de exponenten optelt. Maar bij delen trek je af: 6 − 2 = 4, niet 6 + 2 = 8. Onthoud: vermenigvuldigen = optellen, delen = aftrekken."
        }
      }
    },
    {
      "id": "GET-WETENSCHAP-REKEN-004",
      "familyId": "GET-WETENSCHAP-REKEN",
      "module": "Getalbegrip",
      "tier": 16,
      "levelCode": "E8+",
      "group": 8,
      "skill": "wetenschappelijk",
      "subSkill": "wetenschap_rekenen",
      "questionType": "multiple_choice",
      "question": "Een scheikundige berekent: $(5 \\times 10^{3}) \\times (6 \\times 10^{2})$. Schrijf het antwoord in wetenschappelijke notatie.",
      "options": ["$3 \\times 10^{6}$", "$30 \\times 10^{5}$", "$3 \\times 10^{5}$", "$30 \\times 10^{6}$"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Normaliseren",
            "content": "In wetenschappelijke notatie staat de coëfficiënt tussen 1 en 10. Als de coëfficiënt ≥ 10, schuif dan de komma en verhoog de exponent. $30 \\times 10^{5} = 3 \\times 10^{6}$.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "wetenschap_normaliseren",
      "variantIndex": 4,
      "citoDifficulty": 0.46,
      "citoDiscrimination": 0.68,
      "pedagogy": {
        "dok": 3,
        "misconceptionTags": [
          { "id": "get.wetenschap-niet-genormaliseerd", "label": "Coëfficiënt niet tussen 1 en 10", "optionIndex": 1 },
          { "id": "get.wetenschap-coefficient-fout", "label": "Coëfficiënten verkeerd berekend", "optionIndex": 2 },
          { "id": "get.wetenschap-niet-genormaliseerd", "label": "Coëfficiënt te groot, exponent niet verhoogd", "optionIndex": 3 }
        ]
      },
      "feedback": {
        "explanationText": "Vermenigvuldig en normaliseer. 5 × 6 = 30 en $10^{3} \\times 10^{2} = 10^{5}$. Tussenresultaat: $30 \\times 10^{5}$. Normaliseer: $30 = 3 \\times 10^{1}$. Dus $3 \\times 10^{1} \\times 10^{5} = 3 \\times 10^{6}$.",
        "solutionSteps": [
          "Coëfficiënten: 5 × 6 = 30",
          "Exponenten: 3 + 2 = 5 → $10^{5}$",
          "Tussenresultaat: $30 \\times 10^{5}$",
          "Normaliseer: $30 = 3 \\times 10^{1}$",
          "$3 \\times 10^{1} \\times 10^{5} = 3 \\times 10^{6}$"
        ],
        "distractorExplanations": {
          "0": "Goed! $30 \\times 10^{5} = 3 \\times 10^{6}$ (genormaliseerd).",
          "1": "Je dacht waarschijnlijk dat $30 \\times 10^{5}$ al in wetenschappelijke notatie staat. Maar de coëfficiënt moet tussen 1 en 10 zijn. Onthoud: 30 ≥ 10, dus normaliseer: $3 \\times 10^{6}$.",
          "2": "Je dacht waarschijnlijk dat 5 × 6 = 3. Maar 5 × 6 = 30, en $30 \\times 10^{5} = 3 \\times 10^{6}$. Onthoud: vermenigvuldig de coëfficiënten correct.",
          "3": "Je dacht waarschijnlijk dat je de exponent verdubbelt. Maar $30 \\times 10^{5} = 3 \\times 10^{6}$, niet $30 \\times 10^{6}$. Onthoud: als je de coëfficiënt door 10 deelt, verhoog je de exponent met 1."
        }
      }
    }
  ]
}
